require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-como-puede-fortalecer-el-bid-su-marco-de-politicas.json") })
        }
      }, "path---es-mx-update-como-puede-fortalecer-el-bid-su-marco-de-politicas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-como-puede-fortalecer-el-bid-su-marco-de-politicas!./.cache/json/es-mx-update-como-puede-fortalecer-el-bid-su-marco-de-politicas.json
// module id = 924
// module chunks = 231608221292675